const encodePath = (value) => encodeURIComponent(String(value || ""));

const isEnabledMenu = (item) => {
  const enabled = item?.enabled ?? item?.status ?? 1;
  const deleted = item?.deleted ?? item?.isDelete ?? 0;
  return Number(enabled) === 1 && Number(deleted) === 0;
};

const resolveMenuTitle = (item) => {
  return item?.relationName || item?.title || item?.name || "";
};

const resolveMenuSort = (item) => {
  const sortValue = item?.sortValue ?? item?.sortNo ?? 0;
  const sortNumber = Number(sortValue);
  return Number.isFinite(sortNumber) ? sortNumber : 0;
};

const buildMenuLink = (item, title) => {
  if (item?.linkUrl) return item.linkUrl;

  const relationId = item?.relationId || item?.spShopCategoryId || item?.categoryId || item?.brandId;
  const menuType = Number(item?.type || item?.menuType || 1);

  if (menuType === 2) {
    const query = new URLSearchParams();
    if (title) query.set("brandInfo", title);
    if (relationId) query.set("brandId", relationId);
    query.set("menuType", "2");
    const search = query.toString();
    return `/product/CategoryList/${encodePath(title || relationId)}${search ? `?${search}` : ""}`;
  }

  const query = new URLSearchParams();
  if (relationId) query.set("spShopCategoryId", relationId);
  const search = query.toString();
  return `/product/CategoryList/${encodePath(title || relationId)}${search ? `?${search}` : ""}`;
};

export function normalizeMallGoodsMenuList(dataList = [], options = {}) {
  const includeHome = options.includeHome !== false;
  const normalized = (Array.isArray(dataList) ? dataList : [])
    .filter(isEnabledMenu)
    .sort((a, b) => resolveMenuSort(b) - resolveMenuSort(a))
    .map((item) => {
      const title = resolveMenuTitle(item);
      return {
        ...item,
        title,
        sortNo: resolveMenuSort(item),
        linkType: item?.linkType ?? 10,
        linkUrl: buildMenuLink(item, title),
      };
    })
    .filter((item) => item.title && item.linkUrl);

  if (!includeHome) return normalized;

  return [
    {
      id: "mall-goods-home",
      title: options.homeTitle || "Home",
      linkType: 10,
      linkUrl: "/",
    },
    {
      id: "mall-goods-all-products",
      title: options.allProductsTitle || "所有產品",
      type: 1,
      linkType: 10,
      linkUrl: "/product/GoodsList",
    },
    ...normalized,
  ];
}
